interface Props {
    header?: string;
    children?: JSX.Element;
    additionalClassNames?: string;
}

const PageContent = (props: Props) => {

    return <div className="pageContainer">
        <div className={`card ${props.additionalClassNames}`}>
            {props.header && props.header.length && <div className="card-header">{props.header}</div>}

            {<div className="card-body">
                {props.children}
            </div>}
        </div>

    </div>
}

export default PageContent;